import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Toolbar/toolbar';
import { css } from '@patternfly/react-styles';
import { formatBreakpointMods, toCamel } from '../../helpers/util';
export var ToolbarGroupVariant;

(function (ToolbarGroupVariant) {
  ToolbarGroupVariant["filter-group"] = "filter-group";
  ToolbarGroupVariant["icon-button-group"] = "icon-button-group";
  ToolbarGroupVariant["button-group"] = "button-group";
})(ToolbarGroupVariant || (ToolbarGroupVariant = {}));

var ToolbarGroupWithRef =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ToolbarGroupWithRef, _React$Component);

  function ToolbarGroupWithRef() {
    _classCallCheck(this, ToolbarGroupWithRef);

    return _possibleConstructorReturn(this, _getPrototypeOf(ToolbarGroupWithRef).apply(this, arguments));
  }

  _createClass(ToolbarGroupWithRef, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          visiblity = _a.visiblity,
          alignment = _a.alignment,
          spacer = _a.spacer,
          spaceItems = _a.spaceItems,
          className = _a.className,
          variant = _a.variant,
          children = _a.children,
          innerRef = _a.innerRef,
          props = __rest(_a, ["visiblity", "alignment", "spacer", "spaceItems", "className", "variant", "children", "innerRef"]);

      return React.createElement("div", Object.assign({
        className: css(styles.toolbarGroup, variant && styles.modifiers[toCamel(variant)], formatBreakpointMods(visiblity, styles), formatBreakpointMods(alignment, styles), formatBreakpointMods(spacer, styles), formatBreakpointMods(spaceItems, styles), className)
      }, props, {
        ref: innerRef
      }), children);
    }
  }]);

  return ToolbarGroupWithRef;
}(React.Component);

export var ToolbarGroup = React.forwardRef(function (props, ref) {
  return React.createElement(ToolbarGroupWithRef, Object.assign({}, props, {
    innerRef: ref
  }));
});